import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiniStoryComponent } from './mini-story.component';
import { ContactBeneficiaryModule } from '../contact-beneficiary/contact-beneficiary.module';
import { VerifiedByModule } from '../verified-by/verified-by.module';
import { StoryPaymentModule } from '../story-payment/story-payment.module';
import { KettoAssuredV2Module } from '../ketto-assured-v2/ketto-assured-v2.module';
import { SharedModule } from '../../shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MultiPatientNoteComponent } from '../multi-patient-note/multi-patient-note.component';


@NgModule({
  declarations: [MiniStoryComponent],
  exports: [MiniStoryComponent],
  imports: [
    CommonModule,
    ContactBeneficiaryModule,
    VerifiedByModule,
    StoryPaymentModule,
    KettoAssuredV2Module,
    SharedModule,
    MatButtonModule,
    MultiPatientNoteComponent
  ]
})
export class MiniStoryModule { }
